import React, {useState} from 'react';
import {Modal, Button, Form, Input, Row, Col, Select} from 'antd';
import './style.scss';


const SubscriptionEnquiryModal = (props) => {
    const {
        isModalOpen,
        setIsModalOpen
    } = props
    const [formSubmitted, setFormSubmitted] = useState(false);

    const modalTitle = formSubmitted ? null : (
        <div>
            <h3 style={{margin: '1rem 0 0 0', fontWeight: 'bold', fontSize: '1.4rem'}}>
                Vieunite Pro Premium Subscription Enquiry
            </h3>
            <p style={{fontSize: '0.8rem', width: '100%', margin: '0.5rem 0 0 0'}}>
                Enter your details in the form below and we will contact you to complete your order.
            </p>
        </div>
    );
    const confirmationContent = (
        <div className={'jj-div'}>
            <p className={'jj-h1'}>Thank you for choosing our Premium subscription package</p>
            <p className={'jj-p'}>Your frames have been reserved. One of our representatives will soon be in contact
                with you to complete your order.</p>
        </div>
    );

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <div className={'subscription-enquiry-modal'}>
            <Modal title={modalTitle}
                   visible={isModalOpen}
                   onOk={handleOk}
                   onCancel={handleCancel}
                   footer={null}
                   centered={true}
            >
                {formSubmitted ? confirmationContent :
                    (
                        <Form
                            layout="vertical"
                            name="enquiryForm"
                            onFinish={(values) => {
                                console.log(values)
                                setFormSubmitted(true)
                            }}
                        >
                            <Row gutter={16}>
                                <Col span={6}>
                                    <Form.Item label="Name"
                                               name="title"
                                               required>
                                        {/*<Input placeholder="Title" />*/}
                                        <Select placeholder="Title" allowClear>
                                            <Select.Option value="Mr">Mr</Select.Option>
                                            <Select.Option value="Mrs">Mrs</Select.Option>
                                            <Select.Option value="Ms">Ms</Select.Option>
                                            <Select.Option value="Dr">Dr</Select.Option>
                                        </Select>

                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item name={'fistName'} required>
                                        <Input placeholder="First" style={{marginTop: '30px'}}/>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item name={'lastName'} required>
                                        <Input placeholder="Last" style={{marginTop: '30px'}}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item name={'businessName'} label="Business name" required>
                                <Input/>
                            </Form.Item>
                            <Form.Item name={'nature'} label="Nature of business">
                                <Select placeholder="Select business type" allowClear>
                                    <Select.Option value="retail">Retail</Select.Option>
                                    <Select.Option value="manufacturing">Manufacturing</Select.Option>
                                    <Select.Option value="it">Information Technology</Select.Option>
                                    <Select.Option value="services">Services</Select.Option>
                                    <Select.Option value="healthcare">Healthcare</Select.Option>
                                    <Select.Option value="finance">Finance</Select.Option>
                                    <Select.Option value="others">Others</Select.Option>
                                    {/* Add other business types as needed */}
                                </Select>
                            </Form.Item>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item name={'email'} label="Email" required>
                                        <Input type="email"/>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item name={'phone'} label="Phone" required>
                                        <Input/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item name={'number'} label="Number of canvases ordered" required>
                                <Input/>
                            </Form.Item>
                            <Form.Item>
                                <Button className={'jj-btn'} key="submit" type="primary" htmlType={"submit"}>
                                    Submit
                                </Button>
                            </Form.Item>
                        </Form>
                    )}

            </Modal>
        </div>
    );
};

export default SubscriptionEnquiryModal;
